import * as v from "valibot";

export const SentryConfig = v.object({
  dsn: v.optional(v.string()),
});

export const sentryConfig = v.parse(SentryConfig, {
  dsn: process.env["GADGET_PUBLIC_SENTRY_DSN"] ?? "",
});
